import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-short-date-level',
  templateUrl: './add-short-date-level.component.html',
})
export class AddShortDateLevelComponent {
  @Output() onSave = new EventEmitter();

  form = this.fb.group({
    name: ['', [Validators.required]],
    days: ['', [Validators.required]],
  });

  constructor(private dialogRef: MatDialogRef<AddShortDateLevelComponent>, private fb: FormBuilder) {}

  save(): void {
    if (this.form.valid) {
      this.onSave.emit(this.form.value);
      this.dialogRef.close();
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
